import ProductState from '../interfaces/state';

const productInitialState: ProductState = {
  items: null,
  categories: null,
};

export default productInitialState;
